import type { SendResetPasswordTokenSchema } from '@labi-api-libs/schemas'
import { httpClient } from '@/services/http/httpClient'

export type SendResetPasswordToken = {
  body: SendResetPasswordTokenSchema
}

export async function sendResetPasswordToken({ body }: SendResetPasswordToken) {
  await httpClient.post('/users/public/password-reset/token', body)
}
